<template>
  <div class="eightPlate">
    <Menu></Menu>
    <div id="eightPlate" style="margin-top: 80px;">
    	<div class="index-first-screen">
    		<img src="../assets/img/eightbgp.jpg" alt="" class="pcStyle"/>
			<img src="../assets/img/eightbgpMb.jpg" alt="" class="mbStyle"/>
    		<div class="index-first-screen-box">
    			<div class="index-first-screen-title">八大业务板块</div>
    			<div class="index-first-screen-text">Business segment</div>
    		</div>
    	</div>
		<div class="eight-screen">
			<div class="eight-screen-box">
				<div>
					<div class="eight-screen-title">废塑料绿色分拣加工中心</div>
					<div class="eight-screen-positon">
						<div>废塑料绿色分拣加工中心</div>
						<div @click="showUrl('1')">···</div>
					</div>
				</div>
				<div>
					<div class="eight-screen-title">塑料高分子新材料制造中心</div>
					<div class="eight-screen-positon">
						<div>塑料高分子新材料制造中心</div>
						<div @click="showUrl('2')">···</div>
					</div>
				</div>
				<div>
					<div class="eight-screen-title">报废汽车绿色拆解中心</div>
					<div class="eight-screen-positon">
						<div>报废汽车绿色拆解中心</div>
						<div @click="showUrl('3')">···</div>
					</div>
				</div>
				<div>
					<div class="eight-screen-title">废钢铁绿色分拣加工中心</div>
					<div class="eight-screen-positon">
						<div>废钢铁绿色分拣加工中心</div>
						<div @click="showUrl('4')">···</div>
					</div>
				</div>
				<div>
					<div class="eight-screen-title">锂电池回收处理中心</div>
					<div class="eight-screen-positon">
						<div>锂电池回收处理中心</div>
						<div @click="showUrl('5')">···</div>
					</div>
				</div>
				<div>
					<div class="eight-screen-title">废轮胎回收处理中心</div>
					<div class="eight-screen-positon">
						<div>废轮胎回收处理中心</div>
						<div @click="showUrl('6')">···</div>
					</div>
				</div>
				<div>
					<div class="eight-screen-title">废家电绿色拆解中心</div>
					<div class="eight-screen-positon">
						<div>废家电绿色拆解中心</div>
						<div @click="showUrl('7')">···</div>
					</div>
				</div>
				<div>
					<div class="eight-screen-title">废纸绿色分拣加工中心</div>
					<div class="eight-screen-positon">
						<div>废纸绿色分拣加工中心</div>
						<div @click="showUrl('8')">···</div>
					</div>
				</div>
			</div>
		</div>
    </div>
	<div class="showNumbver" v-if="showNumbver">
		<div class="closeshowNumbverTop" @click="colseNumber">
			<img src="../assets/img/close1.png" alt="" />
		</div>
		<div class="closeshowNumbver" @click="colseNumber"></div>
		<div class="showNumbverBox">
			<div>
				<img :src="numberImgSrc" alt="" />
			</div>
			<div class="numberTitle">
				{{numberTitle}}
			</div>
			<div class="numberText">
				{{numberText}}
			</div>
		</div>
	</div>
	<Footer></Footer>
  </div>
</template>
<script>
  import axios from "axios";
  import Menu from './menu';
  import Footer from './footer';
  import Swiper,{Navigation, Pagination,Autoplay,Mousewheel} from 'swiper'
  Swiper.use([Navigation, Pagination,Autoplay,Mousewheel])
  export default {
    name: 'eightPlate',
    components:{
     Menu,
	 Footer
    },
     data () {
      return {
		showNumbver:false,
		numberImgSrc:'',
		numberTitle:'',
		numberText:''
      };
    },
	mounted(){
		
	},
	methods: {
		showUrl(i){
			this.showNumbver=true
			if(i==='1'){
				this.numberImgSrc=require('../assets/img/zu1.jpg')
				this.numberTitle='废塑料绿色分拣加工中心'
				this.numberText='废塑料绿色分拣中心对回收废塑料进行分拣、粉碎、造粒加工，作为原料，用于纤维拉丝制做服装、地毯、重新再造塑料制品等领域，每回收1吨废塑料，可节约600千克石油，减少污染90%。'
			}else if(i==='2'){
				this.numberImgSrc=require('../assets/img/zu2.jpg')
				this.numberTitle='塑料高分子新材料制造中心'
				this.numberText='购置台湾宝绿特、德国陶朗、奥地利埃瑞玛等国际领先的生产设备，可生产加工聚对苯二甲酸乙二醇酯（PET）、聚丙烯（PP）聚乙烯（PE）等塑料产品，通过塑料造粒改性，形成高分子材料，产品可达到食品级使用，实现废塑料同级化、高附加值利用。'
			}else if(i==='3'){
				this.numberImgSrc=require('../assets/img/zu3.jpg')
				this.numberTitle='报废汽车绿色拆解中心'
				this.numberText='报废汽车绿色拆解中心对回收报废汽车进行拆解、处置。与市交通部门联网对报废汽车进行实时监控，溯源追溯。'
			}else if(i==='4'){
				this.numberImgSrc=require('../assets/img/zu4.jpg')
				this.numberTitle='废钢铁绿色分拣加工中心'
				this.numberText='废钢铁绿色分拣中心对回收废钢铁进行分拣、剪切、压块、打包，作为原料，用于重炼钢铁，每回收1吨废钢可炼钢800千克，节约铁矿石3吨、节约焦炭1吨。'
			}else if(i==='5'){
				this.numberImgSrc=require('../assets/img/zu5.jpg')
				this.numberTitle='锂电池回收处理中心'
				this.numberText='锂电池回收处理中心是专门从事废旧锂电池回收、处理和资源化利用的设施。这些中心的建立对于环境保护和资源循环利用具有重要意义，因为它们能够减少有害物质的环境污染并回收宝贵的金属资源，如锂、钴、镍等。锂电池回收处理技术不断进步，包括预处理、拆解、物理分离和化学回收等步骤。这些技术的改进有助于提高回收效率和降低环境风险。例如，废旧锂电池回收处理设备的设计现在能够实现锂电池各组成部分的精细分类处理，包括隔膜和石墨粉的单独回收。'
			}else if(i==='6'){
				this.numberImgSrc=require('../assets/img/zu6.jpg')
				this.numberTitle='废轮胎回收处理中心'
				this.numberText='废轮胎回收处理中心是专门用于收集、分类、处理和再利用废旧轮胎的设施。这些中心的建立对于减少环境污染、节约资源和促进循环经济具有重要意义。废轮胎回收处理技术通常包括物理方法（如撕碎、压缩）、化学方法（如热裂解）和机械方法（如再生橡胶生产）等。'
			}else if(i==='7'){
				this.numberImgSrc=require('../assets/img/zu7.jpg')
				this.numberTitle='废家电绿色拆解中心'
				this.numberText='废家电绿色拆解中心建立旨是在减少环境污染，实现资源的循环利用，并促进绿色经济的发展。通过采用先进的技术和管理方法，废家电绿色拆解中心能够有效地处理废旧电器中的有害物质，提取可再利用的材料，如金属、塑料等，从而减少对自然资源的依赖和环境的负担。'
			}else if(i==='8'){
				this.numberImgSrc=require('../assets/img/zu8.jpg')
				this.numberTitle='废纸绿色分拣加工中心'
				this.numberText='哈尔滨循环经济产业园区废纸绿色分拣中心对回收废纸进行分拣、压缩、打包，作为造纸原料再造新纸，每回收1吨废纸，可造新纸850千克，节约木材三万立方米。'
			}
		},
		colseNumber(){
			this.showNumbver=false
		}
	},
  }
</script>
<style scoped>
@import '../assets/scss/commen.scss';
@import '../assets/scss/eightPlate.scss';

</style>


// WEBPACK FOOTER //
// src/components/eightPlate.vue